import { MetaProps } from '../../../../types/IHeader';
import { Person } from 'schema-dts';
import { siteUrl } from '..';

export const person = (
  data: MetaProps,
  localeCode: string,
  localeSlug: string,
): Person => {
  const author = data?.hero?.[0]?.author;
  const name = author?.name || 'Payfit';
  const image = author?.image;
  const idName = name ? name?.replace(/ /g, '-') : 'Payfit';

  return {
    '@type': 'Person',
    '@id': `${siteUrl}/${localeSlug}#/schema/person/${idName}`,
    'url':'https://payfit.com/',
    name: name,
    image: {
      '@type': 'ImageObject',
      inLanguage: localeCode,
      '@id': `${siteUrl}/${localeSlug}#/schema/person/image/`,
      url: image?.url,
      contentUrl: image?.url,
      caption: author?.name,
    },
    description: author?.authorPosition || '',
  };
};
